import { render, staticRenderFns } from "./BoxForm.vue?vue&type=template&id=245ebec1&"
import script from "./BoxForm.vue?vue&type=script&lang=ts&"
export * from "./BoxForm.vue?vue&type=script&lang=ts&"
import style0 from "./BoxForm.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports